// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Set_Serialized from "../Data.Set.Serialized/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Coupons_Internal_Types_CouponData from "../Restaumatic.Coupons.Internal.Types.CouponData/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq1 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Set_Serialized.eqSet(Restaumatic_Coupons_Internal_Types_CouponData.eqCouponData));
var countIsSymbol = {
    reflectSymbol: function () {
        return "count";
    }
};
var couponDataIsSymbol = {
    reflectSymbol: function () {
        return "couponData";
    }
};
var promotionNameIsSymbol = {
    reflectSymbol: function () {
        return "promotionName";
    }
};
var UserLoyaltyIsSymbol = {
    reflectSymbol: function () {
        return "UserLoyalty";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var UserLoyalty = function (x) {
    return x;
};
var toFillFormTypeUserLoyalty = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeUserLoyalty_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldUserLoyalty = function (dictHasField) {
    return dictHasField;
};
var eqUserLoyalty = {
    eq: function (x) {
        return function (y) {
            return x.count === y.count && eq1(x.couponData)(y.couponData) && x.promotionName === y.promotionName;
        };
    }
};
var genericUserLoyalty = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showUserLoyalty = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericUserLoyalty)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(countIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(couponDataIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(promotionNameIsSymbol)(Data_Show.showString))(/* #__PURE__ */ Data_Set_Serialized.showSet(Restaumatic_Coupons_Internal_Types_CouponData.showCouponData)))(Data_Show.showInt))))(UserLoyaltyIsSymbol))
};
var unscrambleDecodeUserLoyalty = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericUserLoyalty)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(countIsSymbol)(Unscramble.decodeInt1)(/* #__PURE__ */ Unscramble.decodeRecordCons(couponDataIsSymbol)(/* #__PURE__ */ Data_Set_Serialized.udecodeSet(Restaumatic_Coupons_Internal_Types_CouponData.ordCouponData)(Restaumatic_Coupons_Internal_Types_CouponData.unscrambleDecodeCouponData))(/* #__PURE__ */ Unscramble.decodeRecordCons(promotionNameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var encodeUserLoyalty = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericUserLoyalty)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(UserLoyaltyIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(promotionNameIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))(couponDataIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.encodeSet(Restaumatic_Coupons_Internal_Types_CouponData.encodeCouponData))))(countIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))))
};
var decodeUserLoyalty = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericUserLoyalty)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(UserLoyaltyIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(promotionNameIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())(couponDataIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.decodeSet(Restaumatic_Coupons_Internal_Types_CouponData.ordCouponData)(Restaumatic_Coupons_Internal_Types_CouponData.decodeCouponData)))())(countIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    UserLoyalty,
    genericUserLoyalty,
    eqUserLoyalty,
    showUserLoyalty,
    encodeUserLoyalty,
    decodeUserLoyalty,
    unscrambleDecodeUserLoyalty,
    toFillFormTypeUserLoyalty,
    hasFieldUserLoyalty,
    newtypeUserLoyalty_
};
